module.exports = require('./_global');


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_path.js
 ** module id = 356
 ** module chunks = 1
 **/